module.exports = __webpack_public_path__ + "media/images/shared/hat-92f449e5ad0fec8e123dcc4dd4f250de.svg";